/**
 * The initial values for the redux state.
 */
export default {
  timestamp: 0,
  currentPage: 0,
  criteria: {
    start_date: '1970-01-01',
    end_date: '1970-01-01',
    company_ids_select2: [],
    location_ids_select2: [],
    columns: {
      source: [],
      target: []
    }
  },
  sorts: {
    doc_date: 'ascend'
  },
  filters: {},
  reportData: [],
  reportIsLoading: false,

  companyOptions: [],
  companyIsLoading: false
};
